/** Whole-module URL moves: legacy prefix → current prefix (bookmarks, emails, notifications keep working). */
export const ROUTE_PREFIX_REDIRECTS: ReadonlyArray<readonly [legacy: string, current: string]> = [
  ['/sales', '/growth'],
];

/** Returns the current path for a legacy-prefixed pathname, or null when no prefix redirect applies. */
export function resolveLegacyPrefixRedirect(pathname: string): string | null {
  for (const [legacy, current] of ROUTE_PREFIX_REDIRECTS) {
    if (pathname === legacy || pathname.startsWith(`${legacy}/`)) {
      return `${current}${pathname.slice(legacy.length)}`;
    }
  }
  return null;
}

/** Current form of a pathname (legacy prefixes rewritten; anything else unchanged). */
export function toCurrentRoutePath(pathname: string): string {
  return resolveLegacyPrefixRedirect(pathname) ?? pathname;
}
